






























import {Component, Vue, Prop, PropSync} from 'vue-property-decorator'
import DButton from '@/components/DButton/button.vue';

import {
  DxPopup
} from 'devextreme-vue';


@Component({
  name: 'AnimatePopup',
  components: {
    DxPopup,
    DButton,
  }
})
export default class extends Vue {

  @PropSync('popupOptions') public localPopupOptions: any;
  @Prop({default: ''}) public msgText!: any;
  @Prop({default: ''}) public msgTitle!: any;

  created() {

  }

  beforeDestroy() {
  }


  onClose() {
    this.localPopupOptions.visible = false;
  }


}
